import React, { useState, useEffect } from "react";

const SportModal = ({ sport, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    if (sport) {
      setFormData({
        name: sport.name,
        description: sport.description,
      });
    }
  }, [sport]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(sport ? { ...sport, ...formData } : formData);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
      <div className="bg-surface-800 border border-line-strong rounded-xl w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">
          {sport ? "Edit Sport" : "Add Sport"}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-2">Name</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              className="w-full p-2 bg-surface-700 rounded"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2">Description</label>
            <textarea
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              className="w-full p-2 bg-surface-700 rounded"
              required
            />
          </div>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-surface-600 rounded"
            >
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-accent rounded">
              {sport ? "Update" : "Add"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SportModal;
